var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 744.664,
    height: 877.859,
    viewBox: "0 0 744.664 877.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#c9c9c9;}.c{fill:#e6e5e5;}.d{fill:#acacac;}.e{fill:#ffca01;opacity:0;}.f{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 744.664,
    height: 877.859,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#525252",
    floodOpacity: 0.518
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-277.5 17.599)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 277.5, -17.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M334.832,0c250.407,4.779,334.832,171.6,334.832,383.272S519.754,802.76,334.832,802.76,0,594.943,0,383.267,84.425-4.783,334.832,0Z",
    transform: "translate(27.5 17.6)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 186,
    cy: 267,
    rx: 186,
    ry: 267,
    transform: "translate(454 151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M185.832,0C364.733,1.75,371.664,120.056,371.664,268.15S288.464,536.3,185.832,536.3,0,416.243,0,268.15,6.93-1.746,185.832,0Z",
    transform: "translate(454 115.111)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 101.5,
    cy: 98,
    rx: 101.5,
    ry: 98,
    transform: "translate(538 193)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 101.5,
    cy: 98,
    rx: 101.5,
    ry: 98,
    transform: "translate(538 193)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.420137ac88d433738b714d85bad12928.svg";
export { ForwardRef as ReactComponent };